<template>
  <div
    v-if="
      !!hbtFlowEnabled &&
      ((!!withChatOnly && hbtFlowChatOnly) ||
        (!withChatOnly && !hbtFlowChatOnly))
    "
    class="resort-humming-bird-container"
  >
    <div class="flex flex-col">
      <h2
        class="fs-24 font-medium mb-5 mt-25 sm:mb-4 mdsm:mt-15 choose-your-room"
        data-sticky-nav-item
      >
        Rooms
      </h2>
    </div>

    <humming-bird-search v-if="!hbtFlowChatOnly" ref="hummingBirdSearch" />
    <div v-else class="mb-8">
      Browse our villa options and either submit a reservation request for a
      personalised quote or chat with a travel expert today.
    </div>

    <div v-if="isLoadingRooms" class="mt-8">
      <loading-item />
    </div>
    <room-result v-else @handle-search="handleSearch"></room-result>
  </div>
</template>

<script>
import HummingBirdSearch from "../Resort/HummingbirdFlow/HummingBirdSearch";
import RoomResult from "../Resort/HummingbirdFlow/RoomResult";
import LoadingItem from "../Search/LoadingItem";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    HummingBirdSearch,
    RoomResult,
    LoadingItem,
  },
  props: ["resortId", "withChatOnly"],
  computed: {
    ...mapState(["isLoadingRooms", "dates", "roomsFilter"]),
    ...mapGetters(["hbtFlowEnabled", "hbtFlowChatOnly"]),
  },
  mounted() {
    this.$store.dispatch("loadRooms");
  },
  methods: {
    handleSearch() {
      if (!this.dates[0]) {
        this.$refs.hummingBirdSearch.showDatePicker();
      } else if (!this.roomsFilter.length) {
        this.$refs.hummingBirdSearch.showOccupancySelector();
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .resort-humming-bird-container ::v-deep .resort-item-loading-large {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
  }
}

.best-price-guarantee-box {
  border: 1.5px solid var(--discount-primary);
  color: var(--discount-primary);
  border-radius: 12px;
}

.best-price-guarantee-box svg {
  fill: var(--discount-primary);
}
</style>
